import { type PrimitiveAtom, useAtom } from 'jotai'
import React from 'react'

import { type SegmentDisplayType } from '~/utils'

import {
  SegmentDisplaySwitcherInner,
  type SegmentDisplaySwitcherInnerProps,
} from './SegmentDisplaySwitcherInner'

export type SegmentDisplaySwitcherProps = Pick<
  SegmentDisplaySwitcherInnerProps,
  'withBoth' | 'withSummary'
> & {
  'data-testid'?: string
  onChange?: (value: SegmentDisplayType) => void
  segmentDisplayTypeAtom: PrimitiveAtom<SegmentDisplayType>
}

export const SegmentDisplaySwitcher = ({
  'data-testid': dataTestId = 'components-features-segment-display-switcher',
  onChange,
  segmentDisplayTypeAtom,
  ...rest
}: SegmentDisplaySwitcherProps) => {
  const [segmentDisplayType, setSegmentDisplayType] = useAtom(
    segmentDisplayTypeAtom,
  )

  const handleChange = React.useCallback<
    NonNullable<SegmentDisplaySwitcherInnerProps['onChange']>
  >(
    (value) => {
      setSegmentDisplayType(value)
      onChange?.(value)
    },
    [onChange, setSegmentDisplayType],
  )

  return (
    <SegmentDisplaySwitcherInner
      {...rest}
      data-testid={dataTestId}
      value={segmentDisplayType}
      onChange={handleChange}
    />
  )
}
